import styled from 'styled-components';

export const DIVIDER_COLOR = '#E6E8E8';
export const CELL_SEPARATOR_COLOR = '#D9D9D9';
export const SCORE_CHIP_BACKGROUND = '#F4F6FE';
export const PRESENCE_COLOR = '#E74150';
export const NO_PRESENCE_COLOR = '#D6D6D6';
export const CELL_VALUE_COLOR = 'rgba(0, 0, 0, 0.85)';

export const SectionTitle = styled.h3`
	margin: 0;
	color: ${({ theme }) => theme.palette.secondary[400]};
	font-size: 1.5625rem;
	font-weight: 600;
	line-height: 2rem;
	letter-spacing: -0.0078rem;
`;

export const Divider = styled.hr`
	width: 100%;
	margin: 0;
	border: none;
	border-top: 1px solid ${DIVIDER_COLOR};
`;
